import React from "react";
import point from "./../../../../../Images/point.png";

const TrendyHairHighlightChunky = () => {
  return (
    <div className="blogWhat-content">
      <h5>6. Chunky Highlights for a Retro Comeback 🎀</h5>
      <p>
        Taking inspiration from the early 2000s, chunky hair highlights are
        back! But this time, they come with a modern touch. Bold blonde streaks
        on dark hair or contrasting colors like copper on black create a
        striking look that turns heads.
      </p>
      <ul>
        <h4>Why It’s Trending:</h4>
        <li>
          <span>
            <img src={point} alt="point" />
            Nostalgic yet modern{" "}
          </span>
        </li>
        <li>
          <span>
            <img src={point} alt="point" /> Great for making a bold statement
          </span>
        </li>
        <li>
          <span>
            <img src={point} alt="point" /> Works on both short and long hair
          </span>
        </li>
      </ul>
    </div>
  );
};

export default TrendyHairHighlightChunky;
